import React from 'react';
import { DateLabel } from '../../DateLabel';
import { Title, ListRowContent, ListCardInner, VideoMetaContent } from '../partials';
import { normalizeVideo } from '../utils';
import { VideoCard } from './../VideoCard';
export var VideoListView = function VideoListView(_ref) {
  var video = _ref.video,
    onClick = _ref.onClick;
  var handleClick = function handleClick() {
    typeof onClick !== 'undefined' && onClick(video);
  };
  var normalized = normalizeVideo(video.body.url);
  return React.createElement(ListRowContent, null, React.createElement(ListCardInner, null, React.createElement(VideoCard, {
    video: normalized,
    onClick: handleClick
  })), React.createElement(VideoMetaContent, null, React.createElement("span", null, React.createElement(DateLabel, {
    date: new Date(video.revision.created),
    format: "lll"
  })), React.createElement(Title, null, video.title)));
};